export default "__VITE_ASSET__u5pT4$WG__"